<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 财务公司提现审核
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box" style="width:1500px">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="收款账号:" label-width="75px" prop="account">
                        <el-input v-model="query.account" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="收款人:" label-width="75px" prop="name">
                        <el-input v-model="query.name" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="提现方式:" label-width="75px" prop="mode">
                        <el-select v-model="query.mode" placeholder="请输入" class="handle-input mr10" @change="inputSearch()">
                             <el-option v-for="item in modeList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                  
                    <el-form-item label="状态:" label-width="75px" prop="status">
                        <el-select v-model="query.status" placeholder="请输入" class="handle-input mr10" @change="inputSearch()">
                            <el-option v-for="item in statusList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请时间" >
                        <el-date-picker class="data" type="date" placeholder="起始日期" v-model="query.start_time" style="width: 150px;padding-right:5px"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" @change="inputSearch()"></el-date-picker>
                        <span>-</span>
                        <el-date-picker  format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="data" type="date" placeholder="结束日期" v-model="query.end_time" style="width: 150px;padding-right:10px;padding-left:5px" @change="inputSearch()">
                        </el-date-picker>
                   </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column prop="id" label="ID" width="55" align="center"  fixed="left"></el-table-column>
                <el-table-column prop="name" label="用户昵称"  align="center"></el-table-column>
                <el-table-column prop="mode" label="提现方式" width="150" align="center"></el-table-column>
                <el-table-column prop="account" label="收款账号"  width="200" align="center"></el-table-column>
                <el-table-column prop="amount" label="提现金额"  align="center"></el-table-column>
                <el-table-column prop="can_withdraw" label="可到账金额"  align="center"></el-table-column>
                <el-table-column prop="status" label="状态"  align="center">
                    <template slot-scope="scope">
                       <span v-if="scope.row.status==1" style="color:rgb(22,162,251)">待审核</span>
                       <span v-else-if="scope.row.status==2" style="color:rgb(236, 160,70)">待打款</span>
                       <span v-else-if="scope.row.status==3" style="color:rgb(22,162,51)">提现成功</span>
                       <span v-else style="color:rgb(242, 94, 67)">提现失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="start_time" label="申请时间" width="180" align="center"></el-table-column>
                <el-table-column prop="end_time" label="到账时间"  width="180" align="center"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini"
                            v-if="scope.row.status ==1"
                             type="primary"
                            @click="updateState(scope.$index,scope.row,'2')"
                        >
                         通过
                        </el-button>
                        <el-button size="mini"
                            v-if="scope.row.status ==1"
                             type="danger"
                            @click="updateState(scope.$index,scope.row,'4')"
                        >
                         不通过
                        </el-button>
                         <el-button size="mini"
                            v-if="scope.row.status ==2"
                             type="warning"
                           
                            @click="updateState(scope.$index,scope.row,'3')"
                        >
                         打款
                        </el-button>
                        <span v-if="scope.row.status == 3" style="color:rgb(22,162,51)">提现成功</span>
                        <span v-if="scope.row.status == 4" style="color:rgb(242, 94, 67)">提现失败</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>


import { post } from '../../../api/request';

export default {
    name: 'basetable',
    data() {
        return {  
            modeList:[{
                label:"微信零钱"
            },{
                label:"微信线下打款"
            },{
                label:"支付宝线下打款"
            },{
                label:"银联线下打款"
            }],
            statusList:[{
                label:'提现成功',
                id:3
            },{
                label:'提现失败',
                id:4
            },{
                label:'待审核',
                id:1
            },{
                label:'代打款',
                id:2
            }],
            pageTotal: 0,      
            query: {
                account:'',
                mode:'',
                name:'',
                start_time:'',
                end_time:'',
                status:'',
                pageIndex: 1,
                pageSize: 8
            },
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    methods: {
        updateState(index,row,status){
            let formdata = new FormData()
            let url = 'admin/Order/updcpycom'
            formdata.append('id',row.id)
            formdata.append('openid',row.openid)
            formdata.append('status',status)
            formdata.append('company_id',this.companyid)
            post(url,formdata).then(res=>{
                if(res.data.msg=="修改成功"){
                    if(status=="2"){
                        this.$message.success("通过审核")
                    }
                    else if(status=="3"){
                        this.$message.success("提现成功")
                    }
                    else if(status=="4"){
                        this.$message.warning("提现失败")
                    }
                    else
                        this.$message.error("操作失败")
                    this.getData()
                }
            })
        },
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //重置搜索
        resetsearch(){
             this.$refs['query'].resetFields()
            this.query.start_time=""
            this.query.end_time=""
            this.query.pageIndex = 1
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            formdata.append('mode',this.query.mode)
            formdata.append('account',this.query.account)
            formdata.append('name',this.query.name)
            formdata.append('start_time',this.query.start_time)
            formdata.append('end_time',this.query.end_time)
            formdata.append('status',this.query.status)
            post('admin/Order/selecpycom',formdata).then(res => {
                if(res.data.data.list){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            formdata.append('mode',this.query.mode)
            formdata.append('account',this.query.account)
            formdata.append('name',this.query.name)
            formdata.append('start_time',this.query.start_time)
            formdata.append('end_time',this.query.end_time)
            formdata.append('status',this.query.status)
            post('admin/Order/selecpycom',formdata).then(res => {
                if(res.data.data){
                    this.tableData = res.data.data.list
                    this.pageTotal = res.data.data.num
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/seal/deletype',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            this.getData()   
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/seal/deletype',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                    this.getData()
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('id',this.editForm.id)
                    formdata.append('type',this.editForm.type)
                    post('admin/seal/updatype',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}

</style>
